/**
 * @fileoverview Provides the `PageContainer` component, a layout container that centers content with a maximum width. It accepts `children` and an optional `className` prop.
 */

import React from 'react'

interface PageContainerProps {
  children: React.ReactNode
  className?: string
}

const PageContainer: React.FC<PageContainerProps> = ({ children, className }) => {
  return (
    <div
      className={className}
      style={{
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%',
      }}
    >
      {children}
    </div>
  )
}

export default PageContainer
